module.exports = __webpack_public_path__ + "static/vibing-cat-1327cfd001bdabcae56d9a4aba27a5dc.gif";